<template>
    <div class="tabs_content">
        <section v-show="allowShowSelectOperator">
            <div class="left">
                <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
                <div class="field_left">
                    <select-box
                        id="operator"
                        v-model="entity.id_operator"
                        :options="operatorOptions"
                        :disabled="!!entity.id"
                    >
                        <translate class="translate">Operátor</translate>
                    </select-box>
                </div>
            </div>
        </section>
        <section>
            <div class="left" v-if="entity.id">
              <detail-entity-info :entity="entity">
                <p>
                  <translate>Počet zařízení</translate>: <span class="date" v-html="entity.device_count"></span></p>
              </detail-entity-info>
            </div>
          <div class="left" v-else>
            <h2 v-translate>Základní údaje</h2>
          </div>
            <div class="right">
                <div class="field_left">
                    <text-input id="serviceWeightCategoryname"
                                :required="true"
                                v-model="entity.name"
                                :disabled="!isEditable"
                                ref="nameref"
                    >
                        <translate class="translate">Název</translate>

                    </text-input>
                </div>
            </div>
        </section>

        <SupportedDeviceTypes
            :is-editable="isEditable"
            :device-types="deviceTypes"
            :entity="entity"/>

        <Codecs
            :is-editable="isEditable"
            :codecs="codecs"
            :entity="entity"
        />
    </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"
import SupportedDeviceTypes from "./SupportedDeviceTypes";
import Codecs from "./Codecs"
import DetailEntityInfo from "../../../common/DetailEntityInfo";

export default {
    name: "BasicSettings",
    components: {Codecs, SupportedDeviceTypes, TextInput, DetailEntityInfo},
    mixins: [formFilterData, requiredFields],
    props: {
        entity: Object,
        isEditable: Boolean,
        deviceTypes: Array,
        codecs: Array,
        operatorOptions: Array,
    },
    computed: {
      allowShowSelectOperator(){
        return this.isEditable ? this.$_createActionAllowedAllOrOwnAndGlobal : this.$_readActionAllowedAllOrOwnAndGlobal;
      }
    },
    methods: {
        validateFormRequiredFields() {
            let nameError = null

            if (!this.entity.name) {
                nameError = this.$gettext('Zadejte název')
            }

            if (nameError !== null) {
                this.setFieldInvalid('nameref', true, nameError)
            } else {
                this.setFieldInvalid('nameref')
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/BasicSettings.vue